"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableCell = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const TableCell_1 = __importDefault(require("@material-ui/core/TableCell"));
exports.TableCell = (props) => {
    const { children, styles = {} } = props, tableCellProps = __rest(props, ["children", "styles"]);
    const useStyles = core_1.makeStyles({
        productTableCell: Object.assign({}, styles)
    });
    const { productTableCell } = useStyles();
    return (react_1.default.createElement(TableCell_1.default, Object.assign({}, tableCellProps, { className: productTableCell }), children ? children : undefined));
};
exports.default = react_1.default.memo(exports.TableCell);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVGFibGVDZWxsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3RhYmxlL1RhYmxlQ2VsbC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFHQSxrREFBeUQ7QUFDekQsNENBRXFFO0FBQ3JFLDRFQUUrRTtBQU1sRSxRQUFBLFNBQVMsR0FBRyxDQUFDLEtBQXFCLEVBQUUsRUFBRTtJQUMvQyxNQUFNLEVBQ0YsUUFBUSxFQUNSLE1BQU0sR0FBRyxFQUFFLEtBRVgsS0FBSyxFQURGLGNBQWMsVUFDakIsS0FBSyxFQUpILHNCQUlMLENBQVEsQ0FBQztJQUVWLE1BQU0sU0FBUyxHQUFHLGlCQUFVLENBQUM7UUFDekIsZ0JBQWdCLG9CQUNULE1BQU0sQ0FDWjtLQUNKLENBQUMsQ0FBQztJQUVILE1BQU0sRUFBRSxnQkFBZ0IsRUFBRSxHQUFHLFNBQVMsRUFBRSxDQUFDO0lBQ3pDLE9BQU8sQ0FDSCw4QkFBQyxtQkFBWSxvQkFDTCxjQUFjLElBQ2xCLFNBQVMsRUFBSyxnQkFBZ0IsS0FFNUIsUUFBUSxDQUFDLENBQUMsQ0FBQyxRQUFRLENBQUMsQ0FBQyxDQUFDLFNBQVMsQ0FDdEIsQ0FDbEIsQ0FBQztBQUNOLENBQUMsQ0FBQztBQUVGLGtCQUFlLGVBQUssQ0FBQyxJQUFJLENBQUMsaUJBQVMsQ0FBQyxDQUFDIn0=